import { render, staticRenderFns } from "./StatsNumbers.vue?vue&type=template&id=02ca838a&scoped=true&"
import script from "./StatsNumbers.vue?vue&type=script&lang=js&"
export * from "./StatsNumbers.vue?vue&type=script&lang=js&"
import style0 from "./StatsNumbers.vue?vue&type=style&index=0&id=02ca838a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ca838a",
  null
  
)

export default component.exports